import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Theme from "../Theme";
import { Button } from "@material-ui/core";
import { ButtonProps } from "@material-ui/core/Button";

export interface IRawLinkButtonProps extends ButtonProps {
  first?: boolean;
  colorOverride?: string;
  bgColorOverride?: string;
  bgColorHoverOverride?: string;
  bgColorDisabledOverride?: string;
}

export interface ILinkButtonProps extends IRawLinkButtonProps {
  to: string;
  children: React.ReactNode;
}

const StyledLinkButton = styled(Button)<IRawLinkButtonProps>`
  color: ${props => props.colorOverride || Theme.colors.white};
  margin: 0 10px;
  &&& a {
    color: ${Theme.colors.white};
    text-decoration: none;
  }
  background-color: ${props => props.bgColorOverride || Theme.colors.buttonPrimary};
  :hover {
    background-color: ${props => props.bgColorHoverOverride || Theme.colors.buttonPrimaryHover};
  }

  ${props =>
    props.disabled &&
    `
    &&& {
      background-color: ${props.bgColorDisabledOverride || Theme.colors.buttonPrimaryDisabled};
      :hover {
        background-color: ${props.bgColorDisabledOverride || Theme.colors.buttonPrimaryDisabled};
      }
    }
    `}

  ${props => props.first && `margin-left: 0;`}

  & .MuiButton-label {
    text-transform: uppercase;
  }
`;

const StyledLink = styled(Link)<ILinkButtonProps>`
  background-color: ${Theme.colors.buttonPrimary};
  color: ${props => props.colorOverride || Theme.colors.white};
  &&& a {
    color: ${Theme.colors.white};
    text-decoration: none;
  }
  background-color: ${props => props.bgColorOverride || Theme.colors.buttonPrimary};
  :hover {
    background-color: ${props => props.bgColorHoverOverride || Theme.colors.buttonPrimaryHover};
  }

  ${props =>
    props.disabled &&
    `
    &&& {
      background-color: ${props.bgColorDisabledOverride || Theme.colors.buttonPrimaryDisabled};
      :hover {
        background-color: ${props.bgColorDisabledOverride || Theme.colors.buttonPrimaryDisabled};
      }
    }
    `}

  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
  display: inline-block;
  font-weight: 500;
  margin: 0px 10px;
  padding: 6px 16px;
  border-radius: 4px;
  min-width: 64px;
  line-height: 1.75;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
`;

export const RawLinkButton = (props: IRawLinkButtonProps) => {
  return (
    <StyledLinkButton variant="contained" {...props}>
      {props.children}
    </StyledLinkButton>
  );
};

export default function LinkButton(props: ILinkButtonProps) {
  return <StyledLink to={props.to}>{props.children}</StyledLink>;
}
